const { useState, useEffect } = require("react")
import Posts from './Posts';
import Pagination from './Pagination';
import _ from 'lodash';

const CustomPagination = ({
    data,
    showPerPage,
    currentPage,
    currentPosts,
    setCurrentPage,
    serverMode = false,
    totalPages = 1,
    onPageChange,
}) => {

    const [nextClass, setNextClass] = useState(currentPosts?.length > showPerPage ? true : false);
    const [prevClass, setPreClass] = useState(true);
    const current = _.reject(data, (row) => row.is_approved !== true).slice((currentPage + 1) * showPerPage - showPerPage, (currentPage + 1) * showPerPage);

    useEffect(() => {
        if (serverMode) {
            setPreClass(currentPage <= 1);
            setNextClass(currentPage >= totalPages);
            return;
        }

        if (current?.length >= 1) {
            setNextClass(false);
        } else {
            setNextClass(true);
        }
        if (currentPage === 1) {
            setPreClass(true);
        } else {
            setPreClass(false);
        }
    }, [current, currentPage, serverMode, totalPages])

    const nextButton = () => {
        if (serverMode) {
            if (currentPage < totalPages) {
                onPageChange(currentPage + 1);
            }
            return;
        }

        if (current?.length >= 1) {
            setNextClass(false);
            setCurrentPage(currentPage + 1)
        }
    };
    const previousButton = () => {
        if (serverMode) {
            if (currentPage > 1) {
                onPageChange(currentPage - 1);
            }
            return;
        }

        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }

    }

    return (
        <>
            <div className='container mt-5'>
                {/* <Posts posts={currentPosts} loading={loading} /> */}
                <Pagination
                    prevClass={prevClass}
                    nextClass={nextClass}
                    postsPerPage={showPerPage}
                    totalPosts={data?.length}
                    nextButton={nextButton}
                    previousButton={previousButton}
                />
            </div>
        </>)
}
export default CustomPagination;